import { createContext } from 'rax';
const SelectContext = createContext({});
export default SelectContext;
